import { parseISO, format } from "date-fns";
import { UTCDate } from "@date-fns/utc";
import { TZDate } from "@date-fns/tz";

export const getLocalDateTime = (utcDateStr: string | null) => {
  if (!utcDateStr) {
    return "";
  }
  const utcDate = parseISO(utcDateStr);
  // return format(new TZDate(new UTCDate(utcDate)), "yyyy年MM月dd日 HH:mm:ss");
  return format(new TZDate(new UTCDate(utcDate)), "yyyy/MM/dd HH:mm:ss");
};

export const getBasicToken = () => {
  return `basic ${process.env.REACT_APP_AUTH_BASIC_TOKEN}`;
};

export const getBankDetailsSummary = ({
  bankTransferName,
  bankTransferBranchName,
  depositTypeCategoryName,
  accountNo,
}: BankDetails) => {
  if (
    !bankTransferBranchName &&
    !bankTransferName &&
    !depositTypeCategoryName &&
    !accountNo
  ) {
    return "";
  }
  return (
    // `${bankTransferName}銀行 ` +
    `銀行：${bankTransferName}  ` +
    (bankTransferBranchName === "本店"
      ? `支店：${bankTransferBranchName}  `
      : `支店：${bankTransferBranchName}  `) +
    `${depositTypeCategoryName} ${accountNo || ""}`
  );
};

export const getAddressSumary = (
  { address1, address2, address3 }: Addresses,
  newLine = true
) => {
  // ask faisal vai
  const newLineChar = newLine ? "" : "";
  return (
    `${address1 ? address1 : ""}` +
    (address2 ? `${newLineChar}${address2}` : "") +
    (address3 ? `${newLineChar}${address3}` : "")
  );
};

export const padNumber = (n: number, width: number) => {
  // return new Array(padding).join("0").slice((padding || 2) * -1) + n;
  const zeros = width + 1 - (n + "").length;
  if (zeros > 0) {
    return Array(zeros).join("0") + n;
  }
  return n;
};

export function base64ToArrayBuffer(data: string) {
  const input = data.substring(data.indexOf(",") + 1);
  const binaryString = window.atob(input);
  const binaryLen = binaryString.length;
  const bytes = new Uint8Array(binaryLen);
  for (let i = 0; i < binaryLen; i++) {
    const ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
}

export const validateIpAddresses = (input: string) => {
  if (input.length === 0) {
    return true;
  }
  // Regular expression to match IPv4 addresses with wildcards (*)
  const ipRegex = /^(\d{1,3}|\*)\.(\d{1,3}|\*)\.(\d{1,3}|\*)\.(\d{1,3}|\*)$/;

  // Split the input by commas and trim any whitespace around each IP
  const ips = input.split(",").map((ip) => ip.trim());

  for (const ip of ips) {
    // Check if the IP matches the regular expression
    if (!ipRegex.test(ip)) {
      return false; // Return false if any IP is invalid
    }

    // Ensure each numeric segment is within the range of 0-255 if it's not a wildcard
    const segments = ip.split(".");
    for (const segment of segments) {
      if (
        segment !== "*" &&
        (parseInt(segment) < 0 || parseInt(segment) > 255)
      ) {
        return false;
      }
    }
  }
  return true; // All IPs are valid
};

export const saveDataAsFile = (
  data: ArrayBufferLike,
  filename: string,
  type:
    | "application/zip"
    | "application/pdf"
    | "application/json"
    | "application/octet-stream"
    | string
) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const blob = new Blob([data], {
    type,
  });
  saveBlob(blob, filename);
};

const saveBlob = (blob: Blob, fileName: string) => {
  const a = document.createElement("a");
  document.body.appendChild(a);
  a.style.display = "none";

  const url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
};

export const timestampToDate = (t: number) => {
  const date = new Date(t);
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();
  return `${year}/${month + 1}/${day}`;
};

export const timestampToDateTime = (t: number) => {
  const date = new Date(t);
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();
  const hour = date.getHours();
  const min = date.getMinutes();
  return `${year}/${month + 1}/${day} ${padNumber(hour, 2)}:${padNumber(
    min,
    2
  )}`;
};

export const getFormattedDate = (s: string) => {
  const year = s.slice(0, 4);
  const month = s.slice(4, 6);
  const date = s.slice(6, 8);
  return `${year}/${month}/${date}`;
};

export const getCorrectedDateString = (s: string, splitter = "/"): string => {
  const splits = s.split(splitter);
  // console.log(splits);
  const month = parseInt(splits[1]);
  const date = parseInt(splits[2]);
  if (month === 2 && date > 28) {
    splits[2] = "28";
  } else if ([4, 6, 9, 11].includes(month) && date > 30) {
    splits[2] = "30";
  } else if (date > 31) {
    splits[2] = "31";
  }
  return splits.join(splitter);
};

export const str2ab = (str: string) => {
  const buf = new ArrayBuffer(str.length * 2); // 2 bytes for each char
  const bufView = new Uint16Array(buf);
  for (let i = 0, strLen = str.length; i < strLen; i++) {
    bufView[i] = str.charCodeAt(i);
  }
  return buf;
};
